import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./LoBanner.css";
import htmlParser from "html-react-parser";

export default function Banner({ BannerData, loanOfficer }) {
  const imgCDNURL = process.env.REACT_APP_CDN + "leadership/";

  return (
    <>
      <div className="bannerbglo">
        <Container className="pt-3">
          <Row>
            <Col sm={12} md={5} lg={5} xl={5} className="dpaHeadingcol">
              <div className="nameledershipsection">
                <div>
                  <p className="leadername">
                    {htmlParser(BannerData.title.firstName)}
                  </p>
                  <p className="leadersirname">
                    {htmlParser(BannerData.title.lastName)}
                    {BannerData.title.surnameNote && (
                      <span className="leadersurnamernote">
                        {htmlParser(BannerData.title.surnameNote)}
                      </span>
                    )}
                  </p>
                  <img src={imgCDNURL + "dashlineb.webp"} className="dashline" alt="line">
                  </img>
                 
                  <div className="listdivvs">
                  {BannerData.nmls ? (
                  <p className="nmlstext">{htmlParser(BannerData.nmls)}</p>
                ) : (
                  ""
                )}
                    <ul className="gain-points">
                    
                      <li>{htmlParser(BannerData.position)}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </Col>

            <Col sm={12} md={7} lg={7} xl={7}>
              <div>
                <a href={BannerData.button?.url} target="_blank">
                  <img
                    src={`${imgCDNURL}${BannerData.button?.icon}`}
                    alt={BannerData.button?.altText || "Button"}
                    className="platBtn"
                  />
                </a>
                <img
                  src={`${imgCDNURL}${BannerData.profileImage}`}
                  alt={loanOfficer.referrerName}
                  className="leaderimg"
                />
                <img
                  src={`${imgCDNURL}${BannerData.mobileprofileImage}`}
                  alt={loanOfficer.referrerName}
                  className="leaderimgmobile"
                />
                <div className="socialicondiv">
                  {BannerData.socialMedia?.map((social, index) => (
                      <a href={social.url} target="_blank" className="curspointer" key={index}>
                    <div className="iconcircle" >
                    
                        <img
                          src={`${imgCDNURL}${social.icon}`}
                          alt={social.altText || "social icon"}
                          className="socilicon"
                          id={social.id || ""}
                        />
                    
                    </div>
                    </a>
                  ))}
                </div>
                <a
                  href={BannerData.connectSection?.url}
                  target="_blank"
                  className="davidlink"
                >
                  <div className="d-flex connectdiv">
                    <img
                      src={`${imgCDNURL}${BannerData.connectSection?.icon}`}
                      alt={BannerData.connectSection?.altText || "Connect Icon"}
                      className="ballena"
                    />
                    <p className="connectchat">
                      {BannerData.connectSection?.text || "Connect via AngelAi"}
                    </p>
                  </div>
                </a>
              </div>
             <div className="d-flex">
              <div className="listdivsmobile">
              {BannerData.nmls ? (
                  <p className="nmlstext">{htmlParser(BannerData.nmls)}</p>
                ) : (
                  ""
                )}
                <ul className="gain-points">
                  <li>{htmlParser(BannerData.position)}</li>
                </ul>
              </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
